import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { keyframes } from '@emotion/core';

class WordCaroussel extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            animate: false,
            currentWord: '',
            currentWordIndex: 0,
            nextWord: '',
            words: props.words ? props.words.split(',') : [],
        };

        this.setTimeoutObj = null;
        this.animationDuration = 500;
        this.animationDelay = 2000;
    }

    setWords() {
        const { words, currentWordIndex } = this.state;

        // Get current word
        const currentWord = words[currentWordIndex];

        // Set next word index
        const nextWordIndex =
            currentWordIndex === words.length - 1 ? 0 : currentWordIndex + 1;

        // Set next word
        const nextWord = words[nextWordIndex];

        // Update state
        this.setState(() => ({
            currentWord,
            nextWord,
            currentWordIndex: nextWordIndex,
            animate: false,
        }));

        // Que animation
        this.setTimeoutObj = setTimeout(() => {
            this.startAnimation();
        }, this.animationDelay);
    }

    startAnimation() {
        // Begin animation
        this.setState(() => ({
            animate: true,
        }));

        // Restart cycle
        this.setTimeoutObj = setTimeout(() => {
            this.setWords();
        }, this.animationDuration);
    }

    componentDidMount() {
        this.setWords();
    }

    componentWillUnmount() {
        clearTimeout(this.setTimeoutObj);
    }

    render() {
        const { animate, currentWord, nextWord } = this.state;
        return (
            <WordWrapper>
                <Word
                    {...{
                        nextWord,
                        animate,
                        animationDuration: this.animationDuration,
                    }}>
                    {currentWord}
                </Word>
            </WordWrapper>
        );
    }
}

const WordWrapper = styled.span`
    position: relative;
    display: inline-block;
    margin-right: 14px;
    line-height: 1;

    perspective: 20000px;
`;

const WordFlip = keyframes`
0% {
    transform: rotateX(0deg);
}
100% {
    transform: rotateX(90deg);
}`;

const Word = styled.div`
    position: relative;
    display: inline-block;
    padding: 0;
    transition: transform 0.3s;
    transform-origin: 50% 0;
    transform-style: preserve-3d;
    backface-visibility: hidden;

    &::before {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 100%;
        content: '${props => props.nextWord}';
        transform: rotateX(-90deg);
        transform-origin: 50% 0;
    }

    animation-name: ${props => (props.animate ? WordFlip : '')};
    animation-duration: ${props => props.animationDuration}ms;
    animation-fill-mode: forwards;
`;

export default WordCaroussel;
